import React from 'react';
import styles from './style.module.scss';
import Image from 'next/image';

export default function NewHomesHeader() {
  return (
    <div className={styles.component}>
      <Image fill={true} src="/next/assets/images/precon-header.png" alt="Zoocasa Pre Construction New Homes" className={styles.image} priority={true} />
      <h1>Explore New Construction Homes</h1>
    </div>
  );
}
